import React, { useEffect, useRef } from 'react'

function Cursor() {
    const cursorRef = useRef(null);

    useEffect(() => {
        const handleMouseMove = (e) => {
            cursorRef.current.setAttribute("style", `top: ${e.pageY - 10}px; left: ${e.pageX - 10}px;`);
        };

        const handleClick = () => {
            cursorRef.current.classList.add("expand");
            setTimeout(() => {
                cursorRef.current.classList.remove("expand");
            }, 500);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('click', handleClick);

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('click', handleClick);
        };
    }, []);
  return (
      <>
          <div className="cursor" ref={cursorRef}></div>
      </>
  )
}

export default Cursor